<section>
  <p>Parcial: {{ cancellationQuote.isPartial ? 'Si' : 'No' }}</p>
  <p>NoShow: {{ cancellationQuote.hasNoShow ? 'Si' : 'No' }}</p>
  <p>GdsRefund: {{ cancellationQuote.isGdsRefund ? 'Si' : 'No' }}</p>
  <p>Void: {{ cancellationQuote.voidActive ? 'Si' : 'No' }}</p>
  <br />
</section>

<section class="columns">
  <app-box-fare
    class="column"
    title="{{
      'cancellation-info.original-fare.original-fare-title' | translate
    }}"
    totalTitle="{{
      'cancellation-info.original-fare.original-fare-total' | translate
    }}"
    [totalValue]="cancellationQuote?.originalFare?.totalAmount"
  >
    <div fare-content>
      <!-- Neto  -->
      <app-general-fare
        [taxAmount]="cancellationQuote?.originalFare.baseAmount"
        [taxes]="cancellationQuote?.originalFare.fareSummaries"
        type="fares"
        title="{{
          'cancellation-info.original-fare.original-fare-net' | translate
        }}"
      ></app-general-fare>

      <!-- Impuestos  -->
      <app-general-fare
        [taxAmount]="cancellationQuote?.originalFare.taxAmount"
        type="taxes"
        [taxes]="cancellationQuote?.originalFare.taxes"
        title="{{
          'cancellation-info.original-fare.original-fare-taxes' | translate
        }}"
      ></app-general-fare>
    </div>
  </app-box-fare>

  <app-box-fare
    class="column"
    title="{{ 'cancellation-info.refund-fare.refund-fare-title' | translate }}"
    totalTitle="{{
      'cancellation-info.refund-fare.refund-fare-estimated-to-return'
        | translate
    }}"
    [totalValue]="cancellationQuote?.refundFare?.refundTotalAmount"
    [totalColorGreen]="true"
  >
    <div fare-content>
      <!-- Neto  -->
      <app-general-fare
        [taxAmount]="cancellationQuote?.refundFare?.baseAmount"
        [taxes]="cancellationQuote?.refundFare?.fareSummaries"
        type="fares"
        title="{{
          'cancellation-info.refund-fare.refund-fare-net' | translate
        }}"
      ></app-general-fare>

      <!-- Penalidades -->
      <app-general-fare
        [hasAmountColor]="true"
        [taxAmount]="cancellationQuote?.refundFare?.penaltyAmount"
        type="penalties"
        [taxes]="cancellationQuote?.refundFare?.penalties"
        title="{{
          'cancellation-info.refund-fare.refund-fare-penality' | translate
        }}"
      ></app-general-fare>

      <!-- IVA -->
      <div class="columns is-vcentered pt-1">
        <div class="column">
          <p class="weight-medium is-capitalized is-size-6">
            {{ 'cancellation-info.refund-fare.iva-fare' | translate }}
          </p>
        </div>
        <div class="column">
          <p
            class="weight-medium is-size-6 is-pulled-right pr-2 has-text-danger"
          >
            {{
              cancellationQuote.refundFare.penaltyVatAmount.amount
                | currency
                  : cancellationQuote.refundFare.penaltyVatAmount.currency
                  : 'symbol' : '1.2-2' : 'en-US'
            }}
          </p>
        </div>
      </div>

      <!-- Impuestos a devolver -->
      <app-refund-taxes
        [refundFare]="cancellationQuote?.refundFare"
        [originalFare]="cancellationQuote?.originalFare"
      ></app-refund-taxes>

      <!-- Fixed charges -->
      <app-general-fare
        [hasAmountColor]="true"
        type="charges"
        [taxAmount]="cancellationQuote?.refundFare?.fixedChargeTotal"
        [taxes]="cancellationQuote?.refundFare?.fixedChargeSummaries"
        title="{{ 'cancellation-info.refund-fare.fixed-charges' | translate }}"
      ></app-general-fare>
    </div>
  </app-box-fare>
</section>
